lmApp
  .service('ImportService', ['$q', '$rootScope',
    function ($q, $rootScope) {
      var service = {};

      service.UploadToCloud = function (image, progress) {
        var deferred = $q.defer();
        if (progress) {
          var progressBar = progress.find('.determinate');
          progress.css({display: 'block'});
        }

        var params = {
          Key: Date.now() + '_' + image.name,
          ContentType: image.type,
          ContentLength: image.size,
          Body: image,
          ACL: 'public-read'
        };

        $rootScope.aws
          .upload(params, function (err, data) {
            if (err) {
              err.url = 'AWS3 CloudServer';
              err.data = image;
              deferred.reject(err);
              return;
            }

            if (progress) progress.css({display: 'none'});
            deferred.resolve(data);
          })
          .on('httpUploadProgress', function (persentage) {
            if (progress) progressBar.css({width: Math.round(persentage.loaded / persentage.total * 100) + '%'});
          }
        );

        return deferred.promise;
      };

      service.CreateNewImport = function (xmlUrl) {
        var deferred = $q.defer();

        var url = 'asset/import/scheduler/schedule';
        var data = {
          url: xmlUrl
        };

        lh.common.request.post(url, data)
          .then(function (response) {
            deferred.resolve(response);
          }, function (reason) {
            reason.url = url;
            reason.data = data;
            deferred.reject(reason);
          });

        return deferred.promise;
      };

      service.CreatePerformImport = function (xmlUrl) {
        var deferred = $q.defer();

        var url = 'asset/import/perform';
        var data = {
          url: xmlUrl
        };

        lh.common.request.post(url, data)
          .then(function (response) {
            deferred.resolve(response);
          }, function (reason) {
            reason.url = url;
            reason.data = data;
            deferred.reject(reason);
          });

        return deferred.promise;
      };

      service.GetImportTasks = function () {
        var deferred = $q.defer();

        var url = 'collection/vod.import/query' + '?t=' + Date.now();

        lh.common.request(url)
          .then(function (response) {
            deferred.resolve(response.collection);
          }, function (reason) {
            reason.url = url;
            reason.data = 'GET';
            deferred.reject(reason);
          });

        return deferred.promise;
      };

      service.GetImportTaskById = function (ids) {
        var deferred = $q.defer();

        var url = 'collection/vod.import/query/dimension/id/eq/'+ ids.join(',') + '?t=' + Date.now();

        lh.common.request(url)
          .then(function (response) {
            deferred.resolve(response.collection);
          }, function (reason) {
            reason.url = url;
            reason.data = 'GET';
            deferred.reject(reason);
          });

        return deferred.promise;
      };

      service.GetTaskItems = function (task) {
        var deferred = $q.defer();

        var url = 'collection/vod.import.item/query/dimension/import_schedule_id/eq/' + task.id + '?t=' + Date.now();

        lh.common.request(url)
          .then(function (response) {
            deferred.resolve(response.collection);
          }, function (reason) {
            reason.url = url;
            reason.data = 'GET';
            deferred.reject(reason);
          });

        return deferred.promise;
      };

      service.GetTaskItemsById = function (ids) {
        var deferred = $q.defer();

        var url = 'collection/vod.import.item/query/dimension/id/eq/' + ids.join(',') + '?t=' + Date.now();

        lh.common.request(url)
          .then(function (response) {
            deferred.resolve(response.collection);
          }, function (reason) {
            reason.url = url;
            reason.data = 'GET';
            deferred.reject(reason);
          });

        return deferred.promise;
      };

      service.GetNodeXml = function (node) {
        var deferred = $q.defer();

        var url = 'asset/import/scheduler/item/xml';

        var data = {
          schedule_item_id: node.id
        };

        lh.common.request.get(url, data)
          .then(function (response) {
            deferred.resolve(response.xml);
          }, function (reason) {
            reason.url = url;
            reason.data = data;
            deferred.reject(reason);
          });

        return deferred.promise;
      };

      service.SaveNodeXml = function (node, xml) {
        var deferred = $q.defer();

        var url = 'asset/import/scheduler/item/xml/update';
        var data = {
          schedule_item_id: node.id,
          xml: xml
        };

        lh.common.request.post(url, data)
          .then(function (response) {
            deferred.resolve(response);
          }, function (reason) {
            reason.url = url;
            reason.data = data;
            deferred.reject(reason);
          });

        return deferred.promise;
      };

      service.CancelImport = function (task) {
        var deferred = $q.defer();

        var url = 'asset/import/scheduler/cancel';
        var data = {
          import_id: task.id
        };

        lh.common.request.post(url, data)
          .then(function (response) {
            deferred.resolve(response);
          }, function (reason) {
            reason.url = url;
            reason.data = data;
            deferred.reject(reason);
          });

        return deferred.promise;
      };

      service.RestartNodes = function (task, ids) {
        var deferred = $q.defer();

        var url = 'asset/import/scheduler/reschedule/item';
        var data = {
          import_id: task.id,
          schedule_item_ids: ids.join(',')
        };

        lh.common.request.post(url, data)
          .then(function (response) {
            deferred.resolve(response);
          }, function (reason) {
            reason.url = url;
            reason.data = data;
            deferred.reject(reason);
          });

        return deferred.promise;
      };

      service.DeleteImport = function (task) {
        var deferred = $q.defer();

        var url = 'asset/import/scheduler/remove';
        var data = {
          import_id: task.id
        };

        lh.common.request.post(url, data)
          .then(function (response) {
            deferred.resolve(response);
          }, function (reason) {
            reason.url = url;
            reason.data = data;
            deferred.reject(reason);
          });

        return deferred.promise;
      };

      return service;
    }]);
